// 个人信息-用户类型
export const userTypeList = [
  { value: 'PERSONAL', label: '个人开发者' },
  { value: 'COMPANY', label: '公司' },
];

// 需要忽略的request的报错
export const ignoreErrorMsg = [
  'Error: Request failed with status code 403',
  'Cancel',
];

// 调用失败原因
export const failTypeList = [
  {
    code: 1, bgColor: 'rgb(254, 213, 0)', color: 'rgba(0, 0, 0, 0.54)', text: '超出最大QPS',
  },
  {
    code: 2, bgColor: 'rgb(0, 145, 234)', color: 'rgb(255, 255, 255)', text: '调用模型失败',
  },
];

// 订单状态
export const serviceStatusMap = {
  NOTSTART: '未开始',
  ONGOING: '使用中',
  SUSPEND: '暂停',
  FINISHED: '已完成',
};

export const serviceStatusList = Object.entries(serviceStatusMap).map(([key, value]) => ({
  key,
  value,
}));

// 订单状态
export const orderStatusMap = {
  UNPAID: '待支付',
  ONGOING: '进行中',
  FINISHED: '已完成',
  ONGOING_UNPAY: '进行中-待支付',
  ONGOING_PAYED: '进行中-已付款',
  OVERDUE: '已逾期',
  SUSPEND: '已中止',
};

// 合同类型
export const contractTypeMap = {
  PREPAID: '预付',
  MONTHLY: '月结',
  FREE: '试用',
};

export const contractTypeList = Object.entries(contractTypeMap).map(([key, value]) => {
  if (key === 'FREE') {
    return {
      key,
      value: `免费${value}`,
    };
  }
  return {
    key,
    value: `${value}套餐`,
  };
});

// 合同状态
export const contractStatusMap = {
  UNCONFIRMED: '未确认',
  APPROVED: '已审批',
  TOPAID: '待支付',
  ONGOING: '进行中',
  FINISHED: '已完成',
  SUSPEND: '已中止',
  TERMINATION: '已终止',
  OVERDUE: '已逾期',
  DENIED: '已拒绝',
  INCHANGE: '变更申请',
};

export const contractStatusList = Object.entries(contractStatusMap).map(([key, value]) => ({
  key,
  value,
}));

// 支付订单类型
export const orderTypeMap = {
  MONTHLY: '基础',
  EXTRA: '超额',
};

// 合同订单
export const contractOrderTypeMap = {
  BASIC: '基础',
  EXTRA: '超额',
};

// 账单状态
export const billStatusMap = {
  TOPAID: '待支付',
  PAID: '已支付',
  OVERDUE: '已逾期',
  CANCELED: '已取消',
  FAILED: '余额不足，扣款失败',
};

export const billStatusList = Object.entries(billStatusMap).map(([key, value]) => ({
  key,
  value,
}));

export const billBalanceStatusList = billStatusList.filter((item) => item.key !== 'OVERDUE');

// 调用类型
export const logTypeMap = {
  MONTH_BASIC: '月结基本套餐',
  MONTH_EXTRA: '月结超额',
  FREE: '免费试用',
  PREPAID: '预付套餐',
};

export const statusMap = {
  'success': '成功',
  'failure': '失败',
};